import {

    FETCH_START,
    FETCH_END,
    CONTRACT_CONFIGURATION_LIST_DATA_SUCCESS,
    CONTRACT_CONFIGURATION_BY_ID,
} from '../../../actions/DesignerStudio/ContractConfiguration/ActionTypes'

const initialState = {
    loading: false,
    contractConfigListData: [],
    contractConfigListDataById: null,
};

const ContractConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_START:
            return {
                ...state,
                loading: true,
            };
        case FETCH_END:
            return {
                ...state,
                loading: false,
            };
        case CONTRACT_CONFIGURATION_LIST_DATA_SUCCESS:
            return {
                ...state,
                contractConfigListData: action.data
            }
        case CONTRACT_CONFIGURATION_BY_ID:
            return {
                ...state,
                contractConfigListDataById: action.data
            }
        default:
            return state;
    }
};

export default ContractConfigurationReducer;
